<template>
  <v-row justify="center">
    <v-dialog
      v-model="enabled"
      persistent
      max-width="600px"
      style="background-color: white"
    >
      <v-toolbar>
        <v-toolbar-title>
          <span v-if="organization">
            <span
              v-if="organization.id !== '-1'"
              style="font-weight: normal !important; font-size: 0.8em"
            >
              {{ `Импорт объектов в организацию: ` }}
            </span>
            <span>{{ ` ${organization.title}` }}</span>
          </span>
          <span v-else-if="title">
            <span style="font-weight: normal !important; font-size: 0.8em">
              {{ title }}
            </span>
          </span>
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="$emit('onCloseOfficeImportDialog')"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-toolbar>
      <OfficeImportComponent
        :organization="organization"
        :action="action"
        @onSuccessCallback="onSuccessCallback"
      />
    </v-dialog>
  </v-row>
</template>
<script>
import OfficeImportComponent from '@/views/import/import-office'
export default {
  name: 'OfficeImportComponentDialog',
  components: { OfficeImportComponent },
  props: {
    enabled: Boolean,
    organization: Object,
    action: String,
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    onSuccessCallback (data) {
      this.$emit('onCloseOfficeImportDialog', data)
    }
  }
}
</script>
